export default __webpack_public_path__ + "static/media/67.e01eec48.png";